import merge from 'deepmerge';

import common from 'common/i18n/common';
import general from './general';
import dashboard from '../modules/dashboard/i18n/dashboard';
import demography from '../modules/demography/i18n/demography';
import metrics from '../modules/metrics/i18n/metrics';
import radio from '../modules/radio/i18n/radio';
import registration from '../modules/registration/i18n/registration';
import sales from '../modules/sales/i18n/sales';
import salesMembers from '../modules/salesMembers/i18n/salesMembers';
import campaigns from '../modules/campaigns/i18n/campaigns';
import tutorials from '../modules/tutorials/i18n/tutorials';
import userManagement from '../modules/userManagement/i18n/userManagement';
import customers from '../modules/customers/i18n/customers';
import spots from '../modules/spots/i18n/spots';
import proposition from '../modules/proposition/i18n/proposition';
import notifications from '../modules/notifications/i18n/notifications';
import userProfile from '../modules/userProfile/i18n/userProfile';
import radioConfiguration from '../modules/radioConfiguration/i18n/radioConfiguration';
import promotion from '../modules/promotions/i18n/promotion';
import salesInventory from '../modules/salesInventory/i18n/salesInventory';
import spotInventory from '../modules/spots/i18n/spotInventory';
import radioAnalyticsConfiguration from '../modules/radioConfiguration/i18n/radioAnalyticsConfiguration';
import history from '../modules/history/i18n/history';
import salesmanDashboard from '../modules/salesDashboard/i18n/salesDashboard';
import pagination from '../modules/pagination/i18n/pagination';
import invoicing from '../modules/billing/i18n/invoicing';
import streaming from '../modules/streaming/i18n/streaming';
import centralMarkets from '../modules/centralMarkets/i18n/centralMarkets';
import currencyPeriods from '../modules/currencyPeriod/i18n/currencyPeriods';

export default merge.all([
  common,
  general,
  dashboard,
  demography,
  proposition,
  metrics,
  radio,
  registration,
  sales,
  salesMembers,
  campaigns,
  tutorials,
  userManagement,
  customers,
  spots,
  notifications,
  userProfile,
  radioConfiguration,
  promotion,
  salesInventory,
  spotInventory,
  radioAnalyticsConfiguration,
  history,
  salesmanDashboard,
  pagination,
  invoicing,
  streaming,
  centralMarkets,
  currencyPeriods,
]);




// WEBPACK FOOTER //
// ./src/statsradio/i18n/translations.js